(function () {
	// Sticky add-to-cart bar (PDP). The bar's button is a PROXY: it clicks the
	// real [data-add-to-cart] button so the theme's AJAX add (Product.js ->
	// slate.Variants -> slate.Connect) and every app listener wired to that
	// button or the cart (Assortion add-ons, Clyde PDP widget, PreOrder Now
	// button swaps) fire exactly as they would on a human click. This file must
	// never POST /cart/add.js itself — that would silently bypass the apps.
	function init() {
		// Scope every lookup to the product section: the cart drawer renders
		// BEFORE <main> in theme.liquid and its line items also contain
		// .product-info > [data-price-wrapper], so document-wide queries would
		// mirror a cart line's price whenever the cart is non-empty.
		var sectionEl = document.querySelector('[data-section-type="product"]');
		if (!sectionEl) return;
		var bar = sectionEl.querySelector('[data-sticky-atc]');
		var buyBox = sectionEl.querySelector('.payment-buttons');
		if (!bar || !buyBox || !('IntersectionObserver' in window)) return;

		var barBtn = bar.querySelector('[data-sticky-atc-btn]');
		var barText = bar.querySelector('[data-sticky-atc-text]');
		var barPrice = bar.querySelector('[data-sticky-atc-price]');
		var priceSrc = sectionEl.querySelector('.product-info [data-price-wrapper]');
		if (!barBtn || !barText) return;

		// Re-query on every use: PreOrder Now can replace the button node.
		function realBtn() { return buyBox.querySelector('[data-add-to-cart]'); }

		// On mobile the Google merchant badge overlaps the bar (its script
		// positions it with inline styles that don't reliably respect the
		// configured margin) — hide it outright while the bar is shown.
		// Loose id match survives widget id variants; setProperty important
		// beats its inline styles. Re-checked on a short timer series since
		// the badge script loads late.
		var mqMobile = window.matchMedia('(max-width: 991.98px)');
		var barShown = false;
		function syncBadge() {
			var badge = document.querySelector('[id*="merchantwidget"]');
			if (!badge) return;
			if (barShown && mqMobile.matches) {
				badge.style.setProperty('display', 'none', 'important');
			} else {
				badge.style.removeProperty('display');
			}
		}

		// Visible only once the buy box has scrolled ABOVE the viewport — by
		// then the shopper has passed the variant pickers and app add-ons.
		var io = new IntersectionObserver(function (entries) {
			var e = entries[entries.length - 1];
			var passed = !e.isIntersecting && e.boundingClientRect.top < 0;
			bar.classList.toggle('on', passed);
			bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
			barShown = passed;
			syncBadge();
		}, { threshold: 0 });
		io.observe(buyBox);
		[2000, 5000, 10000].forEach(function (ms) { setTimeout(syncBadge, ms); });

		function mirrorBtn() {
			var src = realBtn();
			if (!src) { barBtn.disabled = true; return; }
			barBtn.disabled = src.disabled;
			var srcText = src.querySelector('[data-add-to-cart-text]');
			if (srcText && barText.textContent !== srcText.textContent) {
				barText.textContent = srcText.textContent;
			}
		}

		function mirrorPrice() {
			if (!priceSrc || !barPrice) return;
			var copy = priceSrc.cloneNode(true);
			// The copies must never carry the live data hooks (see snippet comment).
			copy.querySelectorAll('[data-product-price], [data-compare-price]').forEach(function (el) {
				el.removeAttribute('data-product-price');
				el.removeAttribute('data-compare-price');
			});
			barPrice.innerHTML = copy.innerHTML;
		}

		mirrorBtn();
		var mo = new MutationObserver(function () { mirrorBtn(); mirrorPrice(); });
		mo.observe(buyBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
		if (priceSrc) mo.observe(priceSrc, { subtree: true, childList: true, characterData: true });

		barBtn.addEventListener('click', function () {
			var src = realBtn();
			if (src && !src.disabled) src.click();
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
